import React, { useState, useEffect, useContext, useMemo } from 'react';
import AuthContext from '../../../../contexts/auth';
import { getClientDomain, translate } from '../../../../utils/Common';

// components
import StatusPlatforms from './StatusPlatforms';
import PackagesPickUpLastYear from './PackagesPickUpLastYear';
import { Card } from '@/components/ui/card';
import { StatTile } from '@/components/ui/stat-tile';
import { Meter } from '@/components/ui/meter';
import { TickMeter } from '@/components/ui/tick-meter';
import PlatformBars from '../components/PlatformBars';
import LatestTransactions from '../components/LatestTransactions';

const AdminHome = () => {
    const UserContext = useContext(AuthContext);
    
    const [statusPlatforms, setStatusPlatforms] = useState(null);
    const [cantPackagesInLocker, setCantPackagesInLocker] = useState(null);
    // const [cashInLockers, setCashInLockers] = useState(null);
    const [clientStats, setClientStats] = useState(null);
    const [cantPackagesPickUp, setCantPackagesPickUp] = useState(null);
    const [cantPackagesPickUpLastYear, setCantPackagesPickUpLastYear] = useState(null);

const mergedDataPlatforms = useMemo(() => {
  if (!statusPlatforms && !cantPackagesInLocker) return [];

  const merged = {};

  const normalizePlatform = (item) => {
    const id = item.IdPlataforma ?? item.id;
    return {
      ...item,
      IdPlataforma: id,
    };
  };

  // Agrega primero las plataformas con estado
  (statusPlatforms || []).forEach(p => {
    const platform = normalizePlatform(p);
    merged[platform.IdPlataforma] = { ...platform, CantPaquetes: 0 };
  });

  // Completa o agrega las plataformas con paquetes
  (cantPackagesInLocker || []).forEach(l => {
    const locker = normalizePlatform(l);
    const id = locker.IdPlataforma ?? locker.id;

    merged[id] = {
      ...(merged[id] || {
        Plataforma: locker.Plataforma,
        Estatus: locker.Estatus || 'OFFLINE',
        LastConnection: '',
        IdPlataforma: id,
      }),
      CantPaquetes: locker.CantPaquetes,
      CantPaquetesReservados: locker.CantPaquetesReservados || 0,
      CantPaquetesColectar: locker.CantPaquetesColectar || 0,
      CantPaquetesVencidos: locker.CantPaquetesVencidos || 0,
    };
  });

  return Object.values(merged);
}, [statusPlatforms, cantPackagesInLocker]);

    useEffect(() => {
        const controller = new AbortController();
        const getDashboardInfo = async () => {
            try {
                const response = await fetch(`${getClientDomain(2)}/dashboard/clients/count/total`, {
                    method: 'GET',
                    headers: {
                        'authorization': `Bearer ${sessionStorage.getItem('token')}`
                    },
                    signal: controller.signal
                });

                const result = await response.json();
                if (result) {
                    if (result.payload) {
                        // The endpoint already returns actives, total, pending
                        // and three time windows; only two of the six were being
                        // read, and both fed cards that were commented out.
                        setClientStats(result.payload[0] || {});
                    }
                    else {
                        setClientStats({});
                    }
                }
            } catch (error) {
                console.log(error);
            }
            try {
                let dataToSend = {};
                dataToSend.mes = new Date().getMonth() + 1;
                dataToSend.ano = new Date().getFullYear();

                const response = await fetch(`${getClientDomain(2)}/dashboard/platforms/stats/pickUpXMonth/user/${UserContext.user?.Ruc}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': `Bearer ${sessionStorage.getItem('token')}`
                    },
                    body: JSON.stringify(dataToSend)
                });

                const result = await response.json();
                if (result) {
                    if (result.code === 200) {
                        if (result.payload) {
                            if (result.payload.length > 0) {
                                setCantPackagesPickUp(result.payload);
                            }
                            else {
                                setCantPackagesPickUp([]);
                            }
                        }
                    }
                    else {
                        setCantPackagesPickUp([]);
                    }
                }
            } catch (error) {
               // console.log(error);
            }
            try {
                let dataToSend = {};
                dataToSend.ano = new Date().getFullYear();
                const response = await fetch(`${getClientDomain(2)}/dashboard/platforms/stats/pickUpLastYear/user/${UserContext.user?.Ruc}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': `Bearer ${sessionStorage.getItem('token')}`
                    },
                    body: JSON.stringify(dataToSend)
                });

                const result = await response.json();
                if (result) {
                    // Was collapsed to a single total on arrival, throwing away the
                    // per-locker split the endpoint returns.
                    setCantPackagesPickUpLastYear(Array.isArray(result.payload) ? result.payload : []);
                }
            } catch (error) {
                // console.log(error);
            }
            try {
                const response = await fetch(`${getClientDomain(2)}/dashboard/platforms/stats/packagesInLockers/user/${UserContext.user?.Ruc}`, {
                    method: 'GET',
                    headers: {
                        'authorization': `Bearer ${sessionStorage.getItem('token')}`
                    },
                    signal: controller.signal
                });

                const result = await response.json();
                if (result) {
                    if (result.payload) {
                        if (result.payload?.length > 0) {
                            setCantPackagesInLocker(result.payload);
                        }
                        else {
                            setCantPackagesInLocker([]);
                        }
                    }
                }
            } catch (error) {
                // console.log(error);
            }
            try {
                const response = await fetch(`${getClientDomain(2)}/dashboard/platforms/status/client/${UserContext.user?.IdCliente}`, {
                    method: 'GET',
                    headers: {
                        'authorization': `Bearer ${sessionStorage.getItem('token')}`
                    },
                    signal: controller.signal
                });

                const result = await response.json();
                if (result) {
                    if (result.payload) {
                        if (result.payload.length > 0) {
                            setStatusPlatforms(result.payload);
                        }
                        else {
                            setStatusPlatforms([]);
                        }
                    }
                }
            } catch (error) {
                console.log(error);
            }
        }

        getDashboardInfo();
        return () => controller.abort();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const lockers = mergedDataPlatforms;
    const online = lockers.filter((l) => String(l.Estatus).toUpperCase() === 'ONLINE').length;
    const inLockers = lockers.reduce((n, l) => n + (l.CantPaquetes || 0), 0);
    const reserved = lockers.reduce((n, l) => n + (l.CantPaquetesReservados || 0), 0);
    const expired = lockers.reduce((n, l) => n + (l.CantPaquetesVencidos || 0), 0);
    const pickedUpYear = (cantPackagesPickUpLastYear || []).reduce((n, p) => n + (p.value || 0), 0);
    const pickedUpMonth = (cantPackagesPickUp || []).reduce((n, p) => n + (p.value || 0), 0);

    const loaded = statusPlatforms !== null && cantPackagesInLocker !== null;

    const Tile = ({ children, className }) => (
        <Card className={`flex flex-col justify-between gap-3 p-4 ${className || ''}`}>
            {children}
        </Card>
    );

    return (
        <div className="space-y-4">
            {/* Lo que está pasando ahora mismo */}
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
                <Tile>
                    <StatTile
                        loading={!loaded}
                        value={inLockers}
                        label={translate("dashboard.home.packages_platforms.title")}
                        hint={`${lockers.length} lockers`}
                    >
                        <Meter
                            segments={[
                                { label: translate("global.status.reservedDoor"), value: reserved, className: 'bg-primary' },
                                { label: translate("global.packages_expired.title"), value: expired, className: 'bg-destructive' },
                            ]}
                            total={inLockers || reserved + expired}
                        />
                    </StatTile>
                </Tile>

                <Tile>
                    <StatTile
                        loading={!loaded}
                        value={`${online} / ${lockers.length}`}
                        label={translate("dashboard.home.lockers_online")}
                        hint={`${lockers.length - online} OFFLINE`}
                    >
                        <TickMeter value={online} total={lockers.length} tone="bg-success" />
                    </StatTile>
                </Tile>

                <Tile>
                    <StatTile
                        loading={cantPackagesPickUpLastYear === null}
                        value={pickedUpYear}
                        label={translate("dashboard.home.packages_pick_up_lastyear.packages.title")}
                        delta={{ value: pickedUpMonth }}
                        hint={translate("global.thisMonth")}
                    />
                </Tile>

                <Tile>
                    <StatTile
                        loading={clientStats === null}
                        value={clientStats?.ClientesActivos ?? 0}
                        label={translate("dashboard.home.active_clients")}
                        delta={{ value: clientStats?.ClientesLast30Days ?? 0 }}
                        hint={translate("dashboard.home.active_clients.last_30_days")}
                    />
                </Tile>
            </div>

            {/* Comparación por locker. One column until xl: locker names are long and
                half a card never fits them — width is what makes this section readable. */}
            <div className="grid grid-cols-1 gap-4 xl:grid-cols-2">
                <Card className="p-4">
                    <div className="mb-3 flex items-baseline justify-between gap-2">
                        <h3 className="m-0 text-sm font-semibold text-foreground">
                            {translate("dashboard.home.package_withdrawn")}
                        </h3>
                        <span className="text-xs text-muted-foreground">
                            {translate("global.thisMonth")} <b className="text-foreground">{pickedUpMonth}</b>
                        </span>
                    </div>
                    <PlatformBars
                        data={cantPackagesPickUp}
                        valueLabel={translate("dashboard.home.packages_platforms.title")}
                        emptyLabel={translate("dashboard.home.platforms_most_use.dont_package")}
                    />
                </Card>

                <Card className="p-4">
                    <div className="mb-3 flex items-baseline justify-between gap-2">
                        <h3 className="m-0 text-sm font-semibold text-foreground">
                            {translate("dashboard.home.packages_pick_up_lastyear.packages.title")}
                        </h3>
                        <span className="text-xs text-muted-foreground">
                            <b className="text-foreground">{pickedUpYear}</b>
                        </span>
                    </div>
                    <PlatformBars
                        data={cantPackagesPickUpLastYear}
                        valueLabel={translate("dashboard.home.packages_platforms.title")}
                        emptyLabel={translate("dashboard.home.packages_pick_up_lastyear")}
                    />
                </Card>
            </div>

            <StatusPlatforms statusPlatforms={ loaded ? mergedDataPlatforms : null } />

            <LatestTransactions />
        </div>
    );
}

export default AdminHome;